import { render, staticRenderFns } from "./LeftSession2.vue?vue&type=template&id=81d374fc&scoped=true"
import script from "./LeftSession2.vue?vue&type=script&lang=js"
export * from "./LeftSession2.vue?vue&type=script&lang=js"
import style0 from "./LeftSession2.vue?vue&type=style&index=0&id=81d374fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d374fc",
  null
  
)

export default component.exports